import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const rootElement = document.getElementById("root");

// NOTE: We intentionally use createRoot (client render) instead of hydrateRoot.
//
// react-snap still pre-renders the full static HTML at build time, and that
// markup ships in build/index.html — so search engines receive the complete,
// crawlable content in the initial HTML response (verified: ~68KB of real
// headings, services, FAQ, contact, etc.). That is what matters for SEO.
//
// This site also renders content that legitimately differs between the
// build-time pre-render and the live client render: particle canvases seeded
// with random values, mouse-driven effects, framer-motion initial states, and
// the `new Date()` year in the footer. Hydrating that mismatched markup throws
// React hydration errors (#418 / #423). A fresh client render avoids those
// errors entirely while keeping the pre-rendered HTML available to crawlers.
const root = createRoot(rootElement);
root.render(<App />);
